import { Button } from '@fabric-ds/react';

import styles from './AITravelPlannerBanner.module.css';

import plannerBannerImg from '../../public/banner-opplevelser.jpg';

export const AITravelPlannerBanner = ({ unleash }) => {
    if (!unleash?.AITravelPlannerBanner) {
        return null;
    }

    return (
        <div className="my-32">
            <section
                className={`
                    flex flex-wrap flex-auto shadow-2 rounded-16 items-center justify-center 
                    md:flex-row-reverse md:flex-nowrap md:justify-between bg-blue-600 text-white
                `}>
                <div className={`w-full h-full overflow-hidden lg:rounded-lg ${styles.ImgWrapper}`}>
                    <img
                        className={`object-cover object-left min-w-full ${styles.Img}`}
                        src={plannerBannerImg.src}
                        alt="En kvinne med ryggen til kameraet, ser mot en klynge av varmluftsballonger i solnedgangen"
                    />
                </div>
                <div
                    className={`
                        py-32 px-32 sm:p-32 lg:p-36 gap-y-16 md:gap-y-24 text-center md:text-left 
                        container flex flex-col flex-auto justify-center items-center md:items-start
                    `}>
                    <div className="flex flex-col gap-y-8 md:gap-y-10">
                        <h2>Finn din neste opplevelse</h2>
                        <p>Få mer ut av reisen din. Utforsk mer enn 300 000 opplevelser og aktiviteter, og skap minner for livet.</p>
                    </div>
                    <Button secondary href="/reise/opplevelser" className="px-28 md:px-40">
                        Utforsk opplevelser
                    </Button>
                </div>
            </section>
        </div>
    );
};
